import {
  TicketSelectorInfoModalMap,
  TicketSelectorMapInfoModelMap,
} from '../types/ticket-selector-info-modal-map';

export const ALL_OPTIONS = 'all';

export const TICKET_SELECTOR_TEXT_INFO_MODAL_MAP_VALUES: TicketSelectorInfoModalMap =
  {
    customer: {
      customer_type_adult_title: {
        title: 'customer_type_adult_title',
        markdown: 'customer_type_adult_description',
        showTicket: false,
      },
      customer_type_student_title: {
        title: 'customer_type_student_title',
        markdown: 'customer_type_student_description',
        showTicket: false,
      },
      customer_type_18andUnder_title: {
        title: 'customer_type_18andUnder_title',
        markdown: 'customer_type_18andUnder_description',
        showTicket: false,
      },
    },
    method: {
      [ALL_OPTIONS]: {
        title: 'travel_method_title',
        markdown: 'travel_method_description_markdown',
        showTicket: false,
      },
    },
    time: {},
    zone: {},
  };

export const TICKET_SELECTOR_MAP_INFO_MODAL: TicketSelectorMapInfoModelMap = {
  travel_zone_walsall: {
    imageAltText: 'travel_zone_map_walsall_image_alt',
    imageUrl: 'travel_zone_map_walsall_image_src',
    title: 'travel_zone_walsall',
  },
  travel_zone_coventry: {
    imageAltText: 'travel_zone_map_coventry_image_alt',
    imageUrl: 'travel_zone_map_coventry_image_src',
    title: 'travel_zone_coventry',
  },
  travel_zone_sandwell_and_dudley: {
    imageAltText: 'travel_zone_map_sandwell_and_dudley_image_alt',
    imageUrl: 'travel_zone_map_sandwell_and_dudley_image_src',
    title: 'travel_zone_sandwell_and_dudley',
  },
  travel_zone_west_midlands: {
    imageAltText: 'travel_zone_map_west_midlands_image_alt',
    imageUrl: 'travel_zone_map_west_midlands_image_src',
    title: 'travel_zone_west_midlands',
  },
  travel_zone_west_midlands_and_metro: {
    imageAltText: 'travel_zone_map_west_midlands_and_metro_image_alt',
    imageUrl: 'travel_zone_map_west_midlands_and_metro_image_src',
    title: 'travel_zone_west_midlands',
  },
};
